/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { 
    Card, 
    Button, 
    Row, 
    Col, 
    CardBody, 
    CardHeader, 
    ButtonGroup, 
    Form, 
    Badge,
    FormGroup, 
    Label, 
    Input ,
    Container,
    DropdownItem,DropdownMenu, UncontrolledDropdown, DropdownToggle
} from 'reactstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import SweetAlert from "react-bootstrap-sweetalert";
import ModalCetakInvoicePesananProduk from './ModalCetakInvoice';
import ModalCetakInvoicePesananProdukDetail from './ModalCetakDetail';

const HistoriInvoicePesananAplikator = () => {
const [alert, setAlert] = React.useState(null);
const token = localStorage.token;
  const warehouse = parseInt(localStorage.warehouse);
//   const redirectPrefix1 = `/cetak/invoice-sjp/cetak/`;
//   const redirectPrefix = `/admin/invoice-sjp/histori/detail/`;
//   const redirectPrefix2= `/admin/invoice-sjp/bkm/`;
  const [rowIndex, setRowIndex] = useState(0);
  const [allInvoiceSo, setAllInvoiceSo] = useState([]);
  const [uomCode, setUomCode] = useState("");
  const [statusaf, setStatusAf] = useState("");
  const [statusd, setStatusD] = useState("");
  const [description, setDescription] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerpage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [currentSort, setCurrentSort] = useState("");
  const [openModalCetak, setOpenModalCetak] = useState(false);
  const [dataModalCetak, setDataModalCetak] = useState({ id: 0,});
  const toggle = () => setOpenModalCetak(!openModalCetak);
  const [openModalCetak1, setOpenModalCetak1] = useState(false);
  const [dataModalCetak1, setDataModalCetak1] = useState({ id: 0,});
  const toggle1 = () => setOpenModalCetak1(!openModalCetak1);
 
  let paginationOption = {
    page: page,
    alwaysShowAllBtns: true,
    override: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPage: perPage,
    totalSize: totalItem,
    onPageChange: (page) => {
      updateDataTable(page, perPage, currentSort, uomCode, description, statusaf, statusd);
    },
    sizePerPageRenderer: () => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          Show{" "}
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                updateDataTable(page, e.target.value, currentSort)
              }}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          }{" "}
          entries.
        </label>
      </div>
    ),
  }

  const updateDataTable = (page, perPage, sort, uomCode, description,statusaf, statusd) => {
    getInvoiceSo(page, perPage, sort, uomCode, description,statusaf, statusd);
    setPage(page);
    setPerpage(perPage);
    setRowIndex((page - 1) * perPage);
    setCurrentSort(sort);
    setUomCode(uomCode);
    setDescription(description);
    setStatusAf(statusaf)
    setStatusD(statusd)
  }

  const handleTableChange = (type, { sortField, sortOrder }) => {
    if (type === "sort") {
      let sort = `${sortField} ${sortOrder}`
      updateDataTable(page, perPage, sort,  uomCode, description,statusaf, statusd)
    }
  }

  
  useEffect(() => {
    getInvoiceSo(page, perPage, currentSort);
  }, []);

  // fungsi dari ambil data
  const getInvoiceSo = (page, perPage, currentSort, invoice_code=null , customer_name=null, status_af=null, status_d=null) => {
    
    let filter = { 
      
      page: page, 
      per_page: perPage,
      warehouse_id : parseInt(warehouse),
      
    };
    if (invoice_code !== null) {
      filter = Object.assign(filter, { invoice_code: invoice_code })
    }
    if (customer_name !== null) {
        filter = Object.assign(filter, { customer_name: customer_name })
    }
    if (status_af !== null) {
      filter = Object.assign(filter, { status_af: status_af })
    }
    if (status_d !== null) {
      filter = Object.assign(filter, { status_d: status_d })
    }
    const data = filter;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/invoice-sjs/page`, data, {
        headers,
      })
      .then((data) => {
        setAllInvoiceSo(data.data.response);
        setPage(data.data.current_page + 1);
        setPerpage(data.data.per_page);
        setTotalItem(data.data.total_item);
      })
      .catch(function (error) {
        setAllInvoiceSo(error.response.data.response);
      });
  }

const setGagalAlert = (id) => {
setAlert(
  <SweetAlert
  danger
  showConfirm
  confirmBtnText="Ok"
  title={id}
  onCancel={hideAlert}
  onConfirm={hideAlert}
  />
);
};

  const hideAlert = () => {
    setAlert(null);
  };

  const reset = () => {
    setUomCode("");
    setDescription("");
    setStatusAf("");
    setStatusD("");
    updateDataTable(1, perPage, currentSort, "", "", "", "");
  }

  const displayModalCetak = (id) => {
    setDataModalCetak({
      id: id,
    });
    setOpenModalCetak(true);
  };

  const displayModalCetak1 = (id) => {
    setDataModalCetak1({
      id: id,
    });
    setOpenModalCetak1(true);
  };

  return (
    <div>
      {alert}
        <SimpleHeader name="Histori" parentName="PO" />
        <Container className="mt--6" fluid>
        <Row>
          <div className="col">
          <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ textAlign: 'left' }}>
                      <Link className="btn btn-link" to="/admin/invoice-sjs">
                        <i className="fa fa-arrow-circle-left fa-2x" /> 
                      </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                      <Form>
                        <Row md="12">
                          <Col md="3">
                            <FormGroup>
                              <Label
                                className="form-control-label"
                                htmlFor="exampleFormControlSelect3"
                            >Kode Invoice</Label>
                              <Input
                              className="form-control-alternative"
                                type="text"
                                placeholder="Masukan Kode Invoice"
                                value={uomCode}
                                onChange={e => updateDataTable(1, perPage, currentSort, e.target.value, description, statusaf, statusd)}
                              />
                            </FormGroup>
                          </Col>
                          {/* <Col md="3">
                            <FormGroup>
                              <Label
                                className="form-control-label"
                                htmlFor="exampleFormControlSelect3"
                            >Customer</Label>
                              <Input
                              className="form-control-alternative"
                                type="text"
                                placeholder="Masukan Customer"
                                value={description}
                                onChange={e => updateDataTable(1, perPage, currentSort, uomCode, e.target.value, statusaf, statusd)}
                              />
                            </FormGroup>
                          </Col> */}
                          <Col md="3">
                              <FormGroup> 
                            <Label
                                className="form-control-label"
                                htmlFor="exampleFormControlSelect3"
                            >
                                Status Finance
                            </Label>
                            <Input
                                name="account"
                                type="select"
                                value={statusaf}
                                onChange={(e) =>
                                updateDataTable(1, perPage, currentSort,uomCode, description, e.target.value,statusd)
                                }
                            >
                                <option value={""}>Pilih Status</option>
                                <option value={3}>Proses</option>
                                <option value={4}>Tolak</option>
                                <option value={5}>Setuju</option>
                            </Input>
                              </FormGroup>
                          </Col>
                          <Col md="3">
                              <FormGroup> 
                            <Label
                                className="form-control-label"
                                htmlFor="exampleFormControlSelect3"
                            >
                                Status Direktur
                            </Label>
                            <Input
                                name="account"
                                type="select"
                                value={statusd}
                                onChange={(e) =>
                                updateDataTable(1, perPage, currentSort,uomCode, description,statusaf,e.target.value)
                                }
                            >
                                <option value={""}>Pilih Status</option>
                                <option value={3}>Proses</option>
                                <option value={4}>Tolak</option>
                                <option value={5}>Setuju</option>
                            </Input>
                              </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Button type="button" onClick={reset} color="secondary">Reset</Button>
                          </Col>
                        </Row>
                      </Form>
                      {allInvoiceSo === null ? (
                        <div>
                          <ToolkitProvider
                                  rowNumber={rowIndex}
                                  data={""}
                                  keyField="id"
                                  columns={[
                                  {
                                    dataField: "no",
                                    text: "#",
                                    sort: true,
                                    page: 1,
                                    formatter: (cell, row, index) => {
                                    let currentRow = ++index;
                                    return currentRow + rowIndex;
                                    },
                                },
                                {
                                  dataField: "",
                                  text: "Tanggal",
                                  sort: true,
                                  },
                                  {
                                    dataField: "",
                                    text: "Kode Invoice",
                                    sort: true,
                                  },
                                  {
                                    dataField: "",
                                    text: "Status",
                                    sort: true,
                                },
                                  ]}
                              >
                                  {(props) => (
                                  <div className="py-4 table-responsive">
                                      <BootstrapTable
                                      remote
                                      {...props.baseProps}
                                      bootstrap4={true}
                                      bordered={false}
                                      hover={true}
                                      onTableChange={handleTableChange}
                                      />
                                  </div>
                                  )}
                          </ToolkitProvider>
                          <CardHeader>
                              <center><h3>DATA NOT FOUND</h3></center>
                          </CardHeader>
                        </div>
                        ):(
                    <ToolkitProvider
                            rowNumber={rowIndex}
                            data={allInvoiceSo}
                            keyField="id"
                            columns={[
                            {
                                dataField: "no",
                                text: "#",
                                sort: true,
                                page: 1,
                                formatter: (cell, row, index) => {
                                let currentRow = ++index;
                                return currentRow + rowIndex;
                                },
                            },
                            {
                              dataField: "transaction_date",
                              text: "Tanggal",
                              sort: true,
                            },
                            {
                              dataField: "invoice_code",
                              text: "Kode Invoice",
                              sort: true,
                            },
                            {
                              dataField: "status_af",
                              text: "Status",
                              sort: true,
                              formatter: (cell, row) => {
                                return row.status_af === 3
                                  ? 
                                    <Badge color="" className="badge-dot mr-4">
                                      <i className="bg-danger" />
                                      Proses
                                    </Badge>
                                  : row.status_af === 4
                                  ? <Badge color="" className="badge-dot mr-4">
                                      <i className="bg-warning" />
                                      Tidak Setuju
                                    </Badge>
                                  : <Badge color="" className="badge-dot mr-4">
                                      <i className="bg-success" />
                                      Setuju
                                    </Badge>;
                              },
                          },
                          {
                            dataField: "status_d",
                            text: "Status",
                            sort: true,
                            formatter: (cell, row) => {
                              return row.status_d === 3
                                ? 
                                  <Badge color="" className="badge-dot mr-4">
                                    <i className="bg-danger" />
                                    Proses
                                  </Badge>
                                : row.status_d === 4
                                ? <Badge color="" className="badge-dot mr-4">
                                    <i className="bg-warning" />
                                    Tolak
                                  </Badge>
                                : <Badge color="" className="badge-dot mr-4">
                                    <i className="bg-success" />
                                    Setuju
                                  </Badge>;
                            },
                        },
                            {
                              dataField: "",
                              text: "",
                              formatter: (cell, row, index) => {
                                return row.status_d === 3
                                  ? <UncontrolledDropdown nav>
                                      <DropdownToggle color="danger">
                                          Tindakan
                                        </DropdownToggle>
                                        <DropdownMenu>
                                              {/* <Link  to={redirectPrefix + row.id}
                                                id={"tooltip_" + row.id}>
                                              <DropdownItem>
                                                <i className="fas fa-user-edit" /><span>Detail</span>
                                              </DropdownItem>
                                              </Link> */}
                                            <DropdownItem
                                            onClick={() => displayModalCetak1(row.id)}
                                          >
                                            <i className="fas fa-print" />
                                            <span>Detail</span>
                                          </DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                  : row.status_d === 4
                                  ?  <UncontrolledDropdown nav>
                                  <DropdownToggle color="danger">
                                      Tindakan
                                    </DropdownToggle>
                                    <DropdownMenu>
                                          {/* <Link  to={redirectPrefix + row.id}
                                            id={"tooltip_" + row.id}>
                                          <DropdownItem>
                                            <i className="fas fa-user-edit" /><span>Detail</span>
                                          </DropdownItem>
                                          </Link> */}
                                          <DropdownItem
                                            onClick={() => displayModalCetak1(row.id)}
                                          >
                                            <i className="fas fa-print" />
                                            <span>Detail</span>
                                          </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                                  : <UncontrolledDropdown nav>
                                  <DropdownToggle color="danger">
                                      Tindakan
                                    </DropdownToggle>
                                    <DropdownMenu>
                                          {/* <Link  to={redirectPrefix2 + row.id}
                                              id={"tooltip_" + row.id}>
                                            <DropdownItem>
                                              <i className="fas fa-book" /><span>Payment</span>
                                            </DropdownItem>
                                          </Link> */}
                                          {/* <DropdownMenu center>
                                              <Link  to={redirectPrefix + row.id}
                                                id={"tooltip_" + row.id}>
                                              <DropdownItem>
                                                <i className="fas fa-user-edit" /><span>Detail</span>
                                              </DropdownItem>
                                              </Link>
                                          </DropdownMenu> */}
                                          <DropdownItem
                                            onClick={() => displayModalCetak(row.id)}
                                          >
                                            <i className="fas fa-print" />
                                            <span>Cetak</span>
                                          </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                              },
                            },
                            ]}
                        >
                            {(props) => (
                            <div className="py-4 table-responsive">
                                <BootstrapTable
                                remote
                                {...props.baseProps}
                                bootstrap4={true}
                                bordered={false}
                                hover={true}
                                pagination={paginationFactory({ ...paginationOption })}
                                onTableChange={handleTableChange}
                                />
                            </div>
                            )}
                    </ToolkitProvider>
                        )}
              </CardBody>
            </Card>
          </div>
        </Row>
        {openModalCetak && (
        <ModalCetakInvoicePesananProduk
          open={openModalCetak}
          data={dataModalCetak}
          toggle={toggle}
        />
      )}
      {openModalCetak1 && (
        <ModalCetakInvoicePesananProdukDetail
          open={openModalCetak1}
          data={dataModalCetak1}
          toggle={toggle1}
        />
      )}
      </Container>
      </div>
  );
}

export default HistoriInvoicePesananAplikator;